import { EmailAddress } from './../models/dms/emailAddress.model';
import { ContactVehiclesResult } from './../models/dms/contactVehicles.model';
import { TasksSearchResult } from './../models/dms/tasksSearchResult.model';
import { SaleSearchResultModel } from './../models/dms/saleSearchResult.model';
import { OpportSortBy, OpportunityStatus, SaleStatus } from './../utility/enums';
import { AddressLookupModel } from 'app/models/dms/addressLookup.model';
import { CompanyLookupDetailsModel } from './../models/dms/addressLookup.model';

import { DocumentModel } from 'app/models/dms/document.model';
import { ListItemModel } from 'app/models/shared/listItem.model';
import { GeneralService } from './general.service';
import { UserService } from 'app/services/user.service';
import { FieldModel } from 'app/models/shared/field.model';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { ContactSearchResultModel } from 'app/models/dms/contactSearchResult.model';

import { LoadingController, AlertController, ToastController } from '@ionic/angular';
import { ContactClass } from 'app/utility/enums';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { CacheService } from './cache.service';
import { ContactModel, ContactResultModel, ContactSummaryModel } from 'app/models/dms/contact.model';
import { Constants } from 'app/utility/constants';
import { SalesStatus, ContactType, SecurityRight, VehicleClass, ContactValidationSetting } from 'app/utility/enums';
import { ContactSearchParamsModel } from 'app/models/dms/contactSearchParams.model';

import { Observable, throwError, Subject } from 'rxjs';
import { TabModel } from 'app/models/shared/tab.model';
import { DateHelper } from 'app/utility/datehelper';
import { OpportunitySearchParamsModel } from 'app/models/dms/opportunitySearchParams.model';
import { OpportunitySearchResultModel } from 'app/models/dms/opportunitySearchResult.model';
import { SingleDocumentUploadModel } from 'app/models/shared/documentUpload.model';
import { StorageService } from './storage.service';
import { BooleanResultModel } from 'app/models/shared/booleanResult.model';

@Injectable({
    providedIn: 'root'
})
export class ContactService
{

    constructor(
        private httpClient: HttpClient,
        private cache: CacheService,
        private loadingController: LoadingController,
        private toastController: ToastController,
        private userService: UserService,
        private generalService: GeneralService,
        public storage: StorageService
    )
    {
        this.getLookups();
    }

    getDealerships(includeNone: boolean): Observable<ContactResultModel[]>
    {
        // let cacheKey: string = 'dealerships_' + includeNone.toString();
        // return this.cache.get(cacheKey, this.getDealershipsInternal(includeNone));

        return this.getCachedDealershipsInternal(includeNone);
    }

    private getCachedDealershipsInternal(includeNone: boolean): Observable<ContactResultModel[]>
    {
        let cacheKey: string = 'dealershipsinternal-' + includeNone;
        let cacheMilliseconds: number = 1 * 60 * 60000; //1 hour
        return this.cache.get(cacheKey, this.getDealershipsInternal(includeNone), cacheMilliseconds);
    }

    private getDealershipsInternal(includeNone: boolean): Observable<ContactResultModel[]>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('includeNone', (!!includeNone).toString());

        return this.httpClient.get<ContactResultModel[]>(Constants.ApiUrl + 'companies/dealerships', { params: httpParams });
    }

    getCachedSuppliers(status: SalesStatus): Observable<ContactResultModel[]>
    {
        let cacheKey: string = 'suppliers_' + status.toString();
        return this.cache.get(cacheKey, this.getSuppliers(status));
    }
    getSuppliers(status: SalesStatus): Observable<ContactResultModel[]>
    {
        // let cacheKey: string = 'suppliers_' + status.toString();
        // return this.cache.get(cacheKey, this.getSuppliersInternal(status));
        return this.getSuppliersInternal(status);
    }

    private getSuppliersInternal(status: SalesStatus): Observable<ContactResultModel[]>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('status', status.toString());

        return this.httpClient.get<ContactResultModel[]>(Constants.ApiUrl + 'companies/suppliers', { params: httpParams });
    }

    public getContacts(searchParams: ContactSearchParamsModel): Observable<ContactSearchResultModel>
    {
        if (!searchParams.salesStatus)
        {
            searchParams.salesStatus = SalesStatus.All;
        }

        searchParams.searchText = searchParams.searchText.replace("+64", "").replace(/^0+/, '');

        let httpParams = new HttpParams();
        for (var p in searchParams)
        {
            httpParams = httpParams.append(p, searchParams[p]);
        }

        // console.log(searchParams);

        return this.httpClient.get<ContactSearchResultModel>(Constants.ApiUrl + 'contacts/search', { params: httpParams });
    }

    getContactById(id: string): Observable<ContactModel>
    {
        return this.httpClient.get<ContactModel>(Constants.ApiUrl + 'contacts/' + id);
    }
    // selectContactsByIds(ids: string[]): Observable<ContactResultModel[]> {
    //     let httpParams = new HttpParams();
    //     httpParams = httpParams.set('contactIdCsv', ids.join(','));

    //     return this.httpClient.get<ContactResultModel[]>(Constants.ApiUrl + 'contacts/selectContactsByIds', { params: httpParams });
    // }

    getContactInitials(contact: ContactResultModel): string
    {
        let initials = '';
        // console.log("getContactInitials", contact);

        if (contact)
        {
            if (contact.firstName || contact.lastName)
            {
                if (contact.firstName && contact.firstName.length > 0)
                {
                    initials += contact.firstName[0];
                }
                if (contact.lastName && contact.lastName.length > 0)
                {
                    initials += contact.lastName[0];
                }
                else if (contact.name && contact.name.length > 0)
                {
                    initials += contact.name[0];
                }
            }
            else
            {
                if (contact.name && contact.name.length > 0)
                {
                    initials += contact.name[0];
                }
                else if (contact.displayName && contact.displayName.length > 0)
                {
                    initials += contact.displayName[0];
                }
            }
        }
		// console.log("getContactInitials", initials);
        return initials;
    }

    getContactColourClass(contact: ContactResultModel): string
    {
        let initial = '';
        let className = '';
        let checkName = contact ? (contact.displayName || '') : '';

        if (checkName.length > 0)
        {
            initial = checkName[0].toLowerCase();
        }

        if (!(/^[a-z]$/.test(initial)))
        {
            initial = '';
        }

        if (initial === '')
        {
            initial = '0';
        }

        return 'contact-class-' + initial;
    }

    insertContact(contact: ContactModel): Observable<ContactModel>
    {
        return this.httpClient.post<ContactModel>(Constants.ApiUrl + 'contacts/new', contact);
    }

    saveContact(contact: ContactModel): Observable<ContactModel>
    {
        if (contact.contactClass=="Individual")
        {
            contact.contactGeneral.dob = this.getDobString(contact.contactGeneral.birthDate);
            contact.contactGeneral.driverLicenseExpiry = this.getValidDate(contact.contactGeneral.driverLicenseExpiry);
        }
        if (contact.id == Constants.EmptyGuid)
        {
            return this.httpClient.post<ContactModel>(Constants.ApiUrl + 'contacts/new', contact);
        }
        else
        {
            return this.httpClient.put<ContactModel>(Constants.ApiUrl + 'contacts/' + contact.id, contact);
        }
    }

    getValidDate(date: Date): Date
    {
        //check if date is before min date
        var minDate = new Date(Constants.DateMinimum);
        if (!date || date < minDate)
        {
            return minDate;
        }
        return date;
    }

    getDobString(birthDate: Date): string
    {
        return DateHelper.getDateTimeAsFormat(birthDate, Constants.DateFormatShortISO);
    }

    async launchLoadingController()
    {
        const loading = await this.loadingController.create({
            message: 'Saving',
            duration: 60000
        });
        return await loading.present();
    }


    getContactTemplate(contactClass: ContactClass, contactType: ContactType): Observable<ContactModel>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('contactClass', contactClass.toString());
        httpParams = httpParams.set('contactType', contactType.toString());

        return this.httpClient.get<ContactModel>(Constants.ApiUrl + 'contacts/new', { params: httpParams });
    }

    handleError(error: any): void
    {
        var errorTitle = '';
        var errorMessage = '';
        var showAlert = false;

        console.error(error);
        var dtoError = JSON.parse(error.error.entityDataJson);
        // console.log(dtoError);
        if (dtoError && dtoError.Message != null)
        {
            //api error
            errorTitle = "Error";
            errorMessage = dtoError.Message;
            showAlert = true;
        }
        else
        {
            errorTitle = "Error";
            errorMessage = error.message;
        }

        if (showAlert)
        {
            this.presentAlert(errorTitle, errorMessage);
            this.loadingController.dismiss();
        }
        else
        {
            this.showToastAlert(errorTitle + ':\r\n\r\n' + errorMessage);
            this.loadingController.dismiss();
        }

        //window.alert(errorMessage);
        throwError(errorMessage);
    }

    async showToastAlert(message: string, color: string = "danger", duration: number = 3000)
    {
        const toast = await this.toastController.create({
            message: message,
            buttons: [
				{
					side: 'end',
					icon: 'close-circle-outline',
					role: 'cancel',
					handler: () =>
					{
						toast.dismiss();
					}
				}
            ],
            position: 'bottom',
            color: color,
            duration: 10000
        });
        toast.present();
    }

    async presentAlert(title, message)
    {
		this.userService.presentAlert(title, message);
    }

    public getCachedContactsIndex(contactClass: ContactClass, contactType: ContactType, filterByAccountOwnerId: boolean, salesStatus: SalesStatus = SalesStatus.All): Observable<string[]>
    {
        let cacheKey: string = 'contactsindex-' + contactClass.toString() + '-' + contactType.toString() + '-' + filterByAccountOwnerId + '-' + salesStatus;
        let cacheMilliseconds: number = 1 * 60 * 60000; //1 hour
        return this.cache.get(cacheKey, this.getContactsIndex(contactClass, contactType, filterByAccountOwnerId, salesStatus), cacheMilliseconds);
    }

    public getContactsIndex(contactClass: ContactClass, contactType: ContactType, filterByAccountOwnerId: boolean, salesStatus: SalesStatus): Observable<string[]>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('contactClass', contactClass.toString());
        httpParams = httpParams.set('contactType', contactType.toString());
        httpParams = httpParams.set('filterByAccountOwnerId', filterByAccountOwnerId ? "true" : "false");
        httpParams = httpParams.set('salesStatus', salesStatus.toString());
        return this.httpClient.get<string[]>(Constants.ApiUrl + 'contacts/index', { params: httpParams });
    }

    public getContactsAutocomplete(query: string, contactClass: ContactClass, contactType: ContactType, filterByAccountOwnerId: boolean, salesStatus: SalesStatus): Observable<string[]>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.set('query', query);
        httpParams = httpParams.set('contactClass', contactClass.toString());
        httpParams = httpParams.set('contactType', contactType.toString());
        httpParams = httpParams.set('filterByAccountOwnerId', filterByAccountOwnerId ? "true" : "false");
        httpParams = httpParams.set('salesStatus', salesStatus.toString());
        return this.httpClient.get<string[]>(Constants.ApiUrl + 'contacts/autocomplete', { params: httpParams });
    }

    getUsers(): Observable<ContactResultModel[]>
    {
        let httpParams = new HttpParams();

        return this.httpClient.get<ContactResultModel[]>(Constants.ApiUrl + 'companies/Users', { params: httpParams });
    }

    getCachedUsers(): Observable<ContactResultModel[]>
    {
        // console.log("get cached users");
        let cacheKey: string = 'users';
        let cacheMilliseconds: number = 60 * 60000; //60 minutes
        return this.cache.get(cacheKey, this.getUsers(), cacheMilliseconds, true);
    }

    public setupMergeFieldGroups(contactFrom: ContactModel, contactTo: ContactModel): TabModel[] {
        const tabsFrom = this.setupFieldGroups(contactFrom, true, true);
        const tabsTo = this.setupFieldGroups(contactTo, true, true);

        const getCaptions = (items: any[], detailObj: any[], key: string) =>
            items.map(item => detailObj.find(x => x.id === item)?.[key] || null)
                .filter(Boolean)
                .join(', ');

        tabsTo.forEach((tabTo, tabIdx) => {
            const tabFrom = tabsFrom[tabIdx];
            tabTo.errorCount = 0;
            tabTo.fieldGroups.forEach((groupTo, groupIdx) => {
                const groupFrom = tabFrom.fieldGroups[groupIdx];
                groupTo.fields.forEach((fieldTo, fieldIdx) => {
                    const fieldFrom = groupFrom.fields[fieldIdx];

                    switch (fieldTo.type) {
                        case 'lookups':
                            const fromCaptionLookups = getCaptions(fieldFrom.value, fieldFrom.detailObject, 'caption');
                            const toCaptionLookups = getCaptions(fieldTo.value, fieldTo.detailObject, 'caption');
                            if ((fromCaptionLookups === '' && fieldFrom.value.length > 0) || (toCaptionLookups === '' && fieldTo.value.length > 0)) {
                                fieldTo.editable = false;
                                fieldTo.viewInEdit = true;
                                break;
                            }
                            fieldTo.detailObject = [
                                new ListItemModel(fieldFrom.value, fromCaptionLookups || '-'),
                                new ListItemModel(fieldTo.value, toCaptionLookups || '-')
                            ];
                            break;
                        case 'toggle':
                            fieldTo.detailObject = [
                                new ListItemModel(fieldFrom.value.toString(), fieldFrom.value ? 'Yes' : 'No'),
                                new ListItemModel(fieldTo.value.toString(), fieldTo.value ? 'Yes' : 'No')
                            ];
                            fieldTo.value = fieldTo.value.toString();
                            fieldFrom.value = fieldFrom.value.toString();
                            break;
                        case 'date':
                            fieldTo.detailObject = [
                                new ListItemModel(fieldFrom.value, DateHelper.getFormattedDate(new Date(fieldFrom.value))),
                                new ListItemModel(fieldTo.value, DateHelper.getFormattedDate(new Date(fieldTo.value)))
                            ];
                            break;
                        case 'segment':
                        case 'select':
                            fieldTo.value = fieldTo.value.toString();
                            fieldFrom.value = fieldFrom.value.toString();
                            const fromCaption = fieldFrom.detailObject.find(x => x.id === fieldFrom.value)?.name || null;
                            const toCaption = fieldTo.detailObject.find(x => x.id === fieldTo.value)?.name || null;
                            if (!fromCaption || !toCaption) {
                                fieldTo.editable = false;
                                fieldTo.viewInEdit = true;
                                break;
                            }
                            fieldTo.detailObject = [
                                new ListItemModel(fieldFrom.value, fromCaption || '-'),
                                new ListItemModel(fieldTo.value, toCaption || '-')
                            ];
                            break;
                        case 'contact':
                            fieldTo.detailObject = [
                                new ListItemModel(fieldFrom.value, fieldFrom.detailObject.displayName || '-'),
                                new ListItemModel(fieldTo.value, fieldTo.detailObject.displayName || '-')
                            ];
                            break;
                        case 'lookup':
                            fieldTo.detailObject = [
                                new ListItemModel(fieldFrom.value, fieldFrom.detailObject.caption || '-'),
                                new ListItemModel(fieldTo.value, fieldTo.detailObject.caption || '-')
                            ];
                            fieldTo.detailObject[0].id = fieldFrom.value;
                            fieldTo.detailObject[1].id = fieldTo.value;
                            if (fieldTo.detailObject[1].name == '-')
                            {
                                var tempValue = fieldTo.value;
                                fieldTo.value = fieldFrom.value;
                                fieldFrom.value = tempValue;
                            }
                            break;
                        default:
                            fieldTo.detailObject = [
                                new ListItemModel(fieldFrom.value, fieldFrom.value || '-'),
                                new ListItemModel(fieldTo.value, fieldTo.value || '-')
                            ];
                            break;
                    }

                    fieldTo.type = 'segment';

                    if (fieldFrom.value.toString() === fieldTo.value.toString())
                    {
                        fieldTo.editable = false;
                        fieldTo.viewInEdit = true;
                    }
                    else if (fieldTo.required && (fieldFrom.value === "" || fieldFrom.value === null || fieldFrom.value === undefined || (Array.isArray(fieldFrom.value) && fieldFrom.value.length === 0)))
                    {
                        fieldTo.editable = false;
                        fieldTo.viewInEdit = true;
                    }
                    else if (fieldTo.value === "" || fieldTo.value === null || fieldTo.value === undefined || (Array.isArray(fieldTo.value) && fieldTo.value.length === 0))
                    {
                        fieldTo.value = fieldFrom.value;
                        if (fieldTo.required)
                        {
                            fieldTo.editable = false;
                            fieldTo.viewInEdit = true;
                        }
                    }
                    if (!fieldTo.editable)
                    {
                        fieldTo.editable = true;
                        fieldTo.disabledSegment = true;
                    }
                });
            });
        });

        return tabsTo;
    }

    public setupFieldGroups(contact: ContactModel, editActive: boolean = false, makeDirty: boolean = false): TabModel[]
    {
        var fieldGroupTabs: TabModel[];
        fieldGroupTabs = [];
        if (this.userService.hasUserRight(SecurityRight.ContactTabsGeneralView))
        {
            fieldGroupTabs.push(new TabModel("General", contact.contactGeneral, this.getFieldGroups(contact, editActive, "general"), makeDirty, "general", "", this.userService.hasUserRight(SecurityRight.ContactTabsGeneralView), this.userService.hasUserRight(SecurityRight.ContactTabsGeneralEdit)));
        }
        if (this.userService.hasUserRight(SecurityRight.ContactTabsAddressesView))
        {
            fieldGroupTabs.push(new TabModel("Address", contact.contactAddresses, this.getFieldGroups(contact, editActive, "addresses"), makeDirty, "addresses", "", this.userService.hasUserRight(SecurityRight.ContactTabsAddressesView), this.userService.hasUserRight(SecurityRight.ContactTabsAddressesEdit)));
        }
        if (this.userService.hasUserRight(SecurityRight.ContactTabsAdminView) &&
			contact.contactAdministration &&
            (this.userService.mcMinVersion("3.2.9")))
        {
            fieldGroupTabs.push(new TabModel("Admin", contact.contactAdministration, this.getFieldGroups(contact, editActive, "administration"), makeDirty, "administration", "", this.userService.hasUserRight(SecurityRight.ContactTabsAdminView), this.userService.hasUserRight(SecurityRight.ContactTabsAdminEdit)));
        }
        return fieldGroupTabs;
    }

    public getFieldGroups(contact: ContactModel, editActive: boolean, groupId: string): FieldGroupModel[]
    {
        var field_groups = [];
        switch (groupId)
        {
            case "general":
                if (contact.contactClass == ContactClass.Business)
                {
                    var group_1 = new FieldGroupModel("Basic");
                    if (this.userService.mcMinVersion("3.2.9"))
                    {
                        var companyName = new FieldModel("Company name", contact.contactGeneral.name, "autocomplete-company", "name", true, true, contact)
                        companyName.hasChildren = true;
                        group_1.addField(companyName);
                    }
                    else {
                        group_1.addField(new FieldModel("Company name", contact.contactGeneral.name, "text", "name", true, true));
                    }

                    if (this.userService.mcMinVersion("3.2.9"))
                    {
                        var nzbn = new FieldModel("NZBN", contact.contactGeneral.nzbn, "text", "nzbn");
                        nzbn.parent = "name";
                        group_1.addField(nzbn);
                    }
                    group_1.addField(new FieldModel("Company number", contact.contactGeneral.companyNo, "text", "companyNo"));

                    var taxNo = new FieldModel("GST number", contact.contactGeneral.taxNumber, "text", "taxNumber");
                    taxNo.parent = "name";
                    group_1.addField(taxNo);

                    group_1.addField(new FieldModel("MVT number", contact.contactGeneral.medTraderNumber, "text", "medTraderNumber"));
                    group_1.addField(new FieldModel("NZTA number", contact.contactGeneral.ltsaNumber, "text", "ltsaNumber"));
                    field_groups.push(group_1);

                    var group_2 = new FieldGroupModel("Contact");
                    group_2.addField(new FieldModel("Mobile", contact.contactGeneral.mobile, "tel", "mobile"));

                    var email = new FieldModel("Email", contact.contactGeneral.primaryEmail, "email", "primaryEmail");
                    email.parent = "name";
                    group_2.addField(email);

                    var mainPhone = new FieldModel("Main phone", contact.contactGeneral.phone, "tel", "phone");
                    mainPhone.parent="name";
                    group_2.addField(mainPhone);

                    group_2.addField(new FieldModel("Other phone", contact.contactGeneral.otherPhone, "tel", "otherPhone"));
                    group_2.addField(new FieldModel("Fax", contact.contactGeneral.fax, "tel", "fax"));
                    if (editActive)
                    {
                        group_2.addField(new FieldModel("Website", contact.contactGeneral.website, "text", "website"));
                    }
                    else
                    {
                        group_2.addField(new FieldModel("Website", contact.contactGeneral.website, "url", "website", true));
                    }
                    field_groups.push(group_2);
                    //todo: referral method, employees
                }
                else
                {
                    var group_1 = new FieldGroupModel("Name"); //, null, this.hasRight(SecurityRight.VehiclesTabsGeneralEdit));
                    group_1.addField(new FieldModel("Salutation", contact.contactGeneral.salutationEnum, "lookup", "salutationEnum", true, false, contact.contactGeneral.salutation));
                    group_1.addField(new FieldModel("First name", contact.contactGeneral.firstName, "text", "firstName", true, false));
                    group_1.addField(new FieldModel("Middle name", contact.contactGeneral.middleName, "text", "middleName"));
                    group_1.addField(new FieldModel("Last name", contact.contactGeneral.name, "text", "name", true, true));
                    group_1.addField(new FieldModel("Preferred name", contact.contactGeneral.preferredName, "text", "preferredName"));
                    group_1.addField(new FieldModel("Initials", contact.contactGeneral.initials, "text", "initials"));
                    var tradingAs = new FieldModel("Trading As", contact.contactGeneral.legalReference, "autocomplete-company", "legalReference")
                    tradingAs.hasChildren = true;
                    group_1.addField(tradingAs);
                    field_groups.push(group_1);

                    var group_2 = new FieldGroupModel("Basic");
                    if (!contact.contactGeneral.dob)
                    {
                        contact.contactGeneral.dob = "1900-01-01";
                    }
                    contact.contactGeneral.birthDate = new Date(contact.contactGeneral.dob);

                    group_2.addField(new FieldModel("Date of birth", contact.contactGeneral.birthDate, "date", "birthDate"));
                    group_2.addField(new FieldModel("Driver licence number", contact.contactGeneral.licenceNo, "text", "licenceNo"));
                    group_2.addField(new FieldModel("Driver licence version", contact.contactGeneral.licenceVer, "text", "licenceVer"));
                    group_2.addField(new FieldModel("Driver licence expiry", contact.contactGeneral.driverLicenseExpiry, "date", "driverLicenseExpiry"));
                    console.log(contact.contactGeneral.gender);
                    contact.contactGeneral.gender.caption = "";
                    group_2.addField(new FieldModel("Gender", contact.contactGeneral.genderEnum, "lookup", "genderEnum", true, false, contact.contactGeneral.gender));
                    group_2.addField(new FieldModel("Marital status", contact.contactGeneral.maritalStatusEnum, "lookup", "maritalStatusEnum", true, false, contact.contactGeneral.maritalStatus));
                    group_2.addField(new FieldModel("Spouse/Partner", contact.contactGeneral.spouseId, "contact", "spouseId", true, false, contact.contactGeneral.spouse));
                    field_groups.push(group_2);

                    var group_3 = new FieldGroupModel("Employment");
                    group_3.addField(new FieldModel("Employer", contact.contactGeneral.employerId, "contact", "employerId", true, false, contact.contactGeneral.employer));
                    field_groups.push(group_3);

                    var group_4 = new FieldGroupModel("Contact");

                    var mobRequired = (this.contactValidationSetting == ContactValidationSetting.AllMandatory || this.contactValidationSetting == ContactValidationSetting.MobilePhoneMandatory);
                    var mob = new FieldModel("Mobile", contact.contactGeneral.mobile, "tel", "mobile", true, mobRequired);
                    switch (this.contactValidationSetting)
                    {
                        case ContactValidationSetting.AllOptional:
                            mob.assistiveText = "";
                            break;
                        case ContactValidationSetting.EmailMandatory:
                            mob.assistiveText = "You must enter an email address";
                            break;
                        case ContactValidationSetting.MobilePhoneMandatory:
                            mob.assistiveText = "You must enter a phone number";
                            break;
                        case ContactValidationSetting.AllMandatory:
                            mob.assistiveText = "You must enter a mobile number and email address";
                            break;
                        case ContactValidationSetting.AnyMandatory:
                        default:
                            mob.assistiveText = "You must enter either a mobile number or email address";
                            break;
                    }
                    group_4.addField(mob);
                    var emailRequired = (this.contactValidationSetting == ContactValidationSetting.AllMandatory || this.contactValidationSetting == ContactValidationSetting.EmailMandatory);
                    group_4.addField(new FieldModel("Email", contact.contactGeneral.primaryEmail, "email", "primaryEmail", true, emailRequired));
                    group_4.addField(new FieldModel("Home Phone", contact.contactGeneral.phone, "tel", "phone"));
                    group_4.addField(new FieldModel("Work Phone", contact.contactGeneral.otherPhone, "tel", "otherPhone"));
                    group_4.addField(new FieldModel("Fax", contact.contactGeneral.fax, "tel", "fax"));
                    field_groups.push(group_4);
                }
                if (contact.contactType == ContactType.Customer)
                {
                    var group_5 = new FieldGroupModel("Referral method");
                    group_5.addField(new FieldModel("Referral method", contact.contactGeneral.referralMethodId, "lookup", "referralMethodId", true, false, contact.contactGeneral.referralMethod, "", VehicleClass.None));
                    field_groups.push(group_5);
                }
                break;
            case "addresses":
                if (editActive)
                {
                    let address_group = new FieldGroupModel("Physical address");
                    var physicalAddress1 = new FieldModel("Address line 1", contact.contactAddresses.physicalAddress1, "autocomplete", "physicalAddress1", true, false, contact.contactAddresses);
                    physicalAddress1.hasChildren = true;
                    physicalAddress1.detailClass = "physical";
                    physicalAddress1.parent = "name";
                    address_group.addField(physicalAddress1);

                    var physicalAddress2 = new FieldModel("Address line 2", contact.contactAddresses.physicalAddress2, "text", "physicalAddress2");
                    physicalAddress2.parent = 'physicalAddress1';
                    address_group.addField(physicalAddress2);

                    var physicalAddress3 = new FieldModel("Address line 3", contact.contactAddresses.physicalAddress3, "text", "physicalAddress3");
                    physicalAddress3.parent = 'physicalAddress1';
                    address_group.addField(physicalAddress3);

                    var physicalSuburb = new FieldModel("Suburb", contact.contactAddresses.physicalSuburb, "text", "physicalSuburb");
                    physicalSuburb.parent = 'physicalAddress1';
                    address_group.addField(physicalSuburb);

                    var physicalCityId = new FieldModel("City", contact.contactAddresses.physicalCityId, "lookup", "physicalCityId", true, false, contact.contactAddresses.physicalCity);
                    physicalCityId.parent = 'physicalAddress1';
                    address_group.addField(physicalCityId);

                    var postcode = new FieldModel("Postcode", contact.contactAddresses.physicalPostCode, "text", "physicalPostCode");
                    postcode.parent = 'physicalAddress1';
                    postcode.hasButton = true;
                    postcode.buttonText = "Visit NZ Post website";
                    postcode.buttonIonIcon = "open-outline";
                    postcode.buttonName = "button-nz-post";
                    postcode.launchOnLoad = true;
                    address_group.addField(postcode);

                    var physicalCountryId = new FieldModel("Country", contact.contactAddresses.physicalCountryId, "select", "physicalCountryId", true, false, this.countries);
					physicalCountryId.allowAdd = true;
					physicalCountryId.allowAddCode = true;
					physicalCountryId.captionCode = 'Item code';
                    address_group.addField(physicalCountryId);

                    var isSameAddress = new FieldModel("Use same details for postal address", contact.contactAddresses.isSameAddress, "toggle", "isSameAddress");
                    isSameAddress.parent = "name";
                    address_group.addField(isSameAddress);
                    field_groups.push(address_group);

					/*
					let address_group_1 = new FieldGroupModel("Physical Address");
					address_group_1.hidden = !contact.contactAddresses.isSameAddress;
					address_group_1.toggleVisibility = true;
					address_group_1.toggleVisibilityOn = 'isSameAddress';
					address_group_1.toggleVisibleWhen = 'true';
					address_group_1.addField(new FieldModel("Postal Address", contact.contactAddresses.postalAddressMultiline, "address", "postal-address", !contact.contactAddresses.isSameAddress, false, null, contact.contactAddresses.isSameAddress?'disabled':''));
					edit_field_groups.push(address_group_1);
					*/

                    let address_group_2 = new FieldGroupModel("Postal address");
                    address_group_2.hidden = contact.contactAddresses.isSameAddress;
                    address_group_2.toggleVisibilityOn = 'isSameAddress';
                    address_group_2.toggleVisibleWhen = 'false';

                    var postalAddress1 = new FieldModel("Address line 1", contact.contactAddresses.postalAddress1, "autocomplete", "postalAddress1");
                    postalAddress1.hasChildren = true;
					postalAddress1.detailClass = "postal";
                    address_group_2.addField(postalAddress1);

                    var postalAddress2 = new FieldModel("Address line 2", contact.contactAddresses.postalAddress2, "text", "postalAddress2");
                    postalAddress2.parent = 'postalAddress1';
                    address_group_2.addField(postalAddress2);

                    var postalAddress3 =  new FieldModel("Address line 3", contact.contactAddresses.postalAddress3, "text", "postalAddress3");
                    postalAddress3.parent = 'postalAddress1';
                    address_group_2.addField(postalAddress3);

                    var postalSuburb = new FieldModel("Suburb", contact.contactAddresses.postalSuburb, "text", "postalSuburb");
                    postalSuburb.parent = 'postalAddress1';
                    address_group_2.addField(postalSuburb);

                    var postalCityId = new FieldModel("City", contact.contactAddresses.postalCityId, "lookup", "postalCityId", true, false, contact.contactAddresses.postalCity);
                    postalCityId.parent = 'postalAddress1';
                    address_group_2.addField(postalCityId);

                    var postalCountryId = new FieldModel("Country", contact.contactAddresses.postalCountryId, "select", "postalCountryId", true, false, this.countries);
                    postalCountryId.parent = 'postalAddress1';
					postalCountryId.allowAdd = true;
					postalCountryId.allowAddCode = true;
					postalCountryId.captionCode = 'Item code';
                    address_group_2.addField(postalCountryId);

                    var postalPostcode = new FieldModel("Postcode", contact.contactAddresses.postalPostCode, "text", "postalPostCode");
                    postalPostcode.parent = 'postalAddress1';
                    postalPostcode.parent = 'physicalAddress1';
                    postalPostcode.hasButton = true;
                    postalPostcode.buttonText = "Visit NZ Post website";
                    postalPostcode.buttonIonIcon = "open-outline";
                    postalPostcode.buttonName = "button-nz-post";
                    postalPostcode.launchOnLoad = true;
                    address_group_2.addField(postalPostcode);

                    field_groups.push(address_group_2);
                }
                else
                {
                    let address_group = new FieldGroupModel("Address");
                    address_group.addField(new FieldModel("Physical Address", contact.contactAddresses.physicalAddressMultiline, "address"));
                    // address_group.addField(new FieldModel("Use Same Details for Postal Address", contact.contactAddresses.isSameAddress, "boolean"));
                    if (contact.contactAddresses.isSameAddress)
                    {
                        address_group.addField(new FieldModel("Postal address", "Same as physical address", "text", "postal-address-message", false, false, null, contact.contactAddresses.isSameAddress ? 'xdisabled' : ''));
                    }
                    else
                    {
                        address_group.addField(new FieldModel("Postal address", contact.contactAddresses.postalAddressMultiline, "address", "postal-address", !contact.contactAddresses.isSameAddress, false, null, contact.contactAddresses.isSameAddress ? 'xdisabled' : ''));
                    }
                    field_groups.push(address_group);

                }
                break;
            case "administration":
                let properties_group = new FieldGroupModel("Properties");
                properties_group.addField(new FieldModel("Active", contact.contactAdministration.active, "toggle", "active"));
                properties_group.addField(new FieldModel("Short Code", contact.contactAdministration.reference, "text", "reference"));

                field_groups.push(properties_group);

                if (contact.contactType==ContactType.Supplier) {
					let sales_group = new FieldGroupModel("Supplier Type");
                    sales_group.addField(new FieldModel("Vehicle Purchase", contact.contactAdministration.salesStatusVehiclePurchase, "toggle", "salesStatusVehiclePurchase"));
                    sales_group.addField(new FieldModel("Reconditioning", contact.contactAdministration.salesStatusReconditioning, "toggle", "salesStatusReconditioning"));
                    sales_group.addField(new FieldModel("Finance", contact.contactAdministration.salesStatusFinance, "toggle", "salesStatusFinance"));
                    sales_group.addField(new FieldModel("Insurance", contact.contactAdministration.salesStatusInsurance, "toggle", "salesStatusInsurance"));
                    sales_group.addField(new FieldModel("Sale Extras", contact.contactAdministration.salesStatusSaleExtras, "toggle", "salesStatusSaleExtras"));

					field_groups.push(sales_group);
                }
                else if (contact.contactType==ContactType.Customer) {
					let sales_group = new FieldGroupModel("Sales");
                    sales_group.addField(new FieldModel("Account Owner", contact.contactAdministration.accountOwnerId, "contact", "accountOwnerId", true, false, contact.contactAdministration.accountOwner));

                    var segmentValues = [
                        new ListItemModel("true", "Prospect"),
                        new ListItemModel("false", "Customer"),
                    ];

                    sales_group.addField(new FieldModel("Customer Type", contact.contactAdministration.salesStatusProspect, 'segment', 'salesStatusProspect', true, false, segmentValues, 'mc-highlight-segment-x'));

					field_groups.push(sales_group);
                }

                let contact_methods_group = new FieldGroupModel("Contact methods");
                contact_methods_group.addField(new FieldModel("Preferred contact method", contact.contactAdministration.correspondPreferenceEnum, "lookup", "correspondPreferenceEnum", true, false, contact.contactAdministration.correspondPreference));
                contact_methods_group.addField(new FieldModel("Email OK", contact.contactAdministration.correspondEmail, "toggle", "correspondEmail"));
                contact_methods_group.addField(new FieldModel("Bulk Email OK", contact.contactAdministration.correspondBulkEmail, "toggle", "correspondBulkEmail"));
                contact_methods_group.addField(new FieldModel("Phone OK", contact.contactAdministration.correspondPhone, "toggle", "correspondPhone"));
                contact_methods_group.addField(new FieldModel("SMS OK", contact.contactAdministration.correspondSms, "toggle", "correspondSms"));
                contact_methods_group.addField(new FieldModel("Mail OK", contact.contactAdministration.correspondMail, "toggle", "correspondMail"));
                if (editActive) {
                    contact_methods_group.addField(new FieldModel("", "AMPD uses the Email OK, SMS OK and Mail OK options to decide what types of correspondence can be sent to this contact. If you unselect all three options AMPD will not send any correspondence to this contact.", "text", "helpertext", false, false, null, '', '', true));
                }
                field_groups.push(contact_methods_group);

                let marketing_group = new FieldGroupModel("Marketing methods");
                marketing_group.addField(new FieldModel("Send marketing material", contact.contactAdministration.marketingAllowed, "toggle", "marketingAllowed"));

                contact.contactAdministration.lastCampaign = (new Date(contact.contactAdministration.marketingLastDate) > new Date("1900-01-02T00:00:00Z"));
                var lastCampaign = new FieldModel("Last campaign", contact.contactAdministration.lastCampaign, "toggle", "lastCampaign");
                lastCampaign.hasChildren = true;
                marketing_group.addField(lastCampaign);

                var marketingDate = new FieldModel("Last campaign date", contact.contactAdministration.marketingLastDate, "date", "marketingLastDate");
                marketingDate.parent = "lastCampaign";
                marketingDate.toggleEditableWhen = 'true';
                marketingDate.editable = contact.contactAdministration.lastCampaign;
                marketing_group.addField(marketingDate);
                field_groups.push(marketing_group);

                let notes_group = new FieldGroupModel("Notes");
                notes_group.addField(new FieldModel("Notes", contact.contactAdministration.comment, "text", "comment"));
                field_groups.push(notes_group);

                let contact_groups_group = new FieldGroupModel("Contact Groups");
                contact_groups_group.addField(new FieldModel('Contact Groups', contact.contactAdministration.contactGroupIds, 'lookups', 'contactGroupIds', true, false, contact.contactAdministration.contactGroups, '', VehicleClass.None));
                field_groups.push(contact_groups_group);
                break;
        }
        return field_groups;
    }

    public countries: ListItemModel[];

    public contactValidationSetting: ContactValidationSetting = ContactValidationSetting.AnyMandatory;
    protected getLookups(): void
    {
        this.generalService.getCachedCountries().subscribe(
			x =>
			{
				//resort the array so items with x.isFrequentlyUsed are first, then sorted by name
				x.sort((a, b) => {
					if (a.isFrequentlyUsed && !b.isFrequentlyUsed) {
						return -1;
					}
					else if (!a.isFrequentlyUsed && b.isFrequentlyUsed) {
						return 1;
					}
					else {
						return a.name.localeCompare(b.name);
					}
				});

				//map the array to a ListItemModel array
				this.countries = x.map(
					y => new ListItemModel(y.countryId.toString(), y.name, '', y.isFrequentlyUsed?'bold':'notbold')
				);
			}
		);

        if (this.userService.mcMinVersion("3.2.00"))
        {
            this.getCachedContactValidationSetting().subscribe(x => this.contactValidationSetting = x);
        }
    }

    getCachedContactValidationSetting(): Observable<ContactValidationSetting>
    {
        let cacheKey: string = 'contact_validation_setting' + status.toString();
        return this.cache.get(cacheKey, this.getContactValidationSetting());
    }

    getContactValidationSetting(): Observable<ContactValidationSetting>
    {
        return this.httpClient.get<ContactValidationSetting>(Constants.ApiUrl + 'Contacts/ContactValidationSetting');
    }

	public getContactDocuments(contactId: string): Observable<DocumentModel[]>
	{
		return this.httpClient.get<DocumentModel[]>(Constants.ApiUrl + 'Contacts/' + contactId + "/Documents");
    }

	public getContactDocument(contactId: string, documentURI:string): Observable<Blob>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('documentURI', documentURI);
		return this.httpClient.get(Constants.ApiUrl + 'Contacts/' + contactId + "/Document", { params: httpParams, responseType: "blob" });
    }

	public getContactDocumentUrl(contactId: string, documentURI:string): Observable<string>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('documentURI', documentURI);
		return this.httpClient.get<string>(Constants.ApiUrl + 'Contacts/' + contactId + "/DocumentUrl", { params: httpParams });
    }
    public handleFieldChangedForTabs(ev:any, fieldGroupTabs:TabModel[])
	{
		// console.log("handleFieldChangedForTabs", ev);

		//see if this field has children
		var changedField: FieldModel = ev.detail.field;
		if (changedField.hasChildren)
		{
			switch (changedField.type)
			{
				case "autocomplete":
					if (ev.autocomplete)
					{
						this.checkAddressChildren(changedField, <AddressLookupModel>ev.autocomplete, fieldGroupTabs);
					}
					break;
				case "autocomplete-company":
					if (ev.autocomplete)
					{
						this.checkCompanyChildren(changedField, <CompanyLookupDetailsModel>ev.autocomplete, fieldGroupTabs);
					}
					break;
			}
		}
	}

	public checkAddressChildren(changedField: FieldModel, autocomplete: AddressLookupModel, fieldGroupTabs: TabModel[], togglePostal=false)
	{

		var prefix = changedField.detailClass;
		// console.log("checkAddressChildren", changedField);
		for (let field_group_tab of fieldGroupTabs)
		{
			for (let field_group of field_group_tab.fieldGroups)
			{
				for (let field_test of field_group.fields)
				{
					if (field_test.parent == changedField.id)
					{
						// console.log("found a child, " + field_test.id);

						var fieldWithoutPrefix = field_test.id.replace(prefix, '');
						field_test.dirty = true;

						// console.log(fieldWithoutPrefix);
						switch (fieldWithoutPrefix)
						{
							case "Suburb":
								field_test.value = autocomplete.locality;
								break;
							// case "Address3":
							//     field_test.value = autocomplete.region;
							//     break;
							case "PostCode":
								field_test.value = autocomplete.postcode;
								break;
							case "CityId":
								field_test.value = autocomplete.cityObject.id;
								// field_test.editValue = '00000000-0000-0000-0000-00000000000';

								field_test.editValue = autocomplete.cityObject.id;
								field_test.detailObject = autocomplete.cityObject;
						}

					}
				}
			}
		}
	}

	public checkCompanyChildren(changedField: FieldModel, autocomplete: CompanyLookupDetailsModel, fieldGroupTabs: TabModel[])
	{
		var prefix = changedField.detailClass;
		// console.log("checkAddressChildren", changedField);

		for (let field_group_tab of fieldGroupTabs)
		{
			for (let field_group of field_group_tab.fieldGroups)
			{
				for (let field_test of field_group.fields)
				{
					if (field_test.parent == changedField.id)
					{
						var fieldWithoutPrefix = field_test.id.replace(prefix, '');
						// console.log("found a child, " + field_test.id, fieldWithoutPrefix);
						field_test.dirty = true;
						switch (fieldWithoutPrefix)
						{
							case "nzbn":
								field_test.value = autocomplete.nzbn;
								break;
							case "taxNumber":
								field_test.value = autocomplete.taxNumber;
								break;
							case "primaryEmail":
								field_test.value = autocomplete.emailAddress;
								break;
							case "phone":
								field_test.value = autocomplete.phone;
								break;
                            case "physicalAddress1":
                                field_test.value = autocomplete.physicalAddress.street_number + (autocomplete.physicalAddress.street_number?" ":"") + autocomplete.physicalAddress.street;
                                this.checkAddressChildren(field_test, autocomplete.physicalAddress, fieldGroupTabs);
                                break;
                            case "postalAddress1":
                                field_test.value = autocomplete.postalAddress.street_number + (autocomplete.postalAddress.street_number?" ":"") + autocomplete.postalAddress.street;
                                this.checkAddressChildren(field_test, autocomplete.postalAddress, fieldGroupTabs);
                                break;
                            case "isSameAddress":
                                // console.log("isSameAddress", field_test);
                                field_test.value = false;
                                field_test.dirty = true;
                                break;
						}

					}
				}
			}
		}
	}

	getLastOpportunity(id: string)
	{
		var searchParams = new OpportunitySearchParamsModel();
		searchParams.customerId = id;
		searchParams.orderBy = OpportSortBy.OpportNo;
		searchParams.orderByDesc = true;
		searchParams.accountOwnerId = Constants.EmptyGuid;
		searchParams.statusEnum = OpportunityStatus.All.toString();
        searchParams.pageSize = 100;
        searchParams.pageNumber = 1;
        // console.log(searchParams);
        let httpParams = new HttpParams();
        for (var p in searchParams)
        {
            var val = searchParams[p];
            httpParams = httpParams.append(p, val);
        }
        return this.httpClient.get<OpportunitySearchResultModel>(Constants.ApiUrl + 'opportunities/search', { params: httpParams });
	}

	public getContactSales(contactId: string): Observable<SaleSearchResultModel>
	{
		return this.httpClient.get<SaleSearchResultModel>(Constants.ApiUrl + 'Contacts/' + contactId + "/Sales");
    }

	public getContactTasks(contactId: string,
        taskTypeId: string = Constants.EmptyGuid, taskStatusId: string = Constants.EmptyGuid, query: string = '',
		startDate: string = Constants.DateMinimum, endDate: string = Constants.DateMaximum, pageNumber: number = 1
    ): Observable<TasksSearchResult>
	{
        let httpParams = new HttpParams();
        httpParams = httpParams.append('taskTypeId', taskTypeId);
        httpParams = httpParams.append('taskStatusId', taskStatusId);
        httpParams = httpParams.append('query', query);
        httpParams = httpParams.append('startDate', startDate);
        httpParams = httpParams.append('endDate', endDate);
        httpParams = httpParams.append('pageNumber', pageNumber.toString());

        return this.httpClient.get<TasksSearchResult>(Constants.ApiUrl + 'contacts/' + contactId + '/tasks', { params: httpParams });
    }

	public getContactVehicles(contactId: string): Observable<ContactVehiclesResult>
	{
		return this.httpClient.get<ContactVehiclesResult>(Constants.ApiUrl + 'Contacts/' + contactId + "/Vehicles");
    }

	public getCachedEmailAddresses(): Observable<EmailAddress[]>
    {
        let cacheKey: string = 'email_addresses';
        return this.cache.get(cacheKey, this.getEmailAddresses());
    }

    public getEmailAddresses(): Observable<EmailAddress[]>
    {
		return this.httpClient.get<EmailAddress[]>(Constants.ApiUrl + 'Companies/EmailAddresses');
    }

    public uploadDocuments(vehicleId: string, files: Blob[], title: string, documentCategory: string, uploadDocumentName: string[]): Observable<any>
	{
		let url = Constants.ApiUrl + 'contacts/' + vehicleId + '/document/new';

		const formData = new FormData();
		for (var i = 0; i < files.length; i++)
		{
			formData.append('document', files[i]);
			formData.append('title', title);
			formData.append('documentCategory', documentCategory);
			formData.append('uploadDocumentName', uploadDocumentName[i]);
		}
		return this.httpClient.post<string[]>(url, formData, { reportProgress: true, observe: 'events' });

	}

	public updateDocument(vehicleId: string, documentUri: string, fileDesc: string, fileCategory: number): Observable<SingleDocumentUploadModel>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('id', vehicleId);
		httpParams = httpParams.append('documentUri', documentUri);
		httpParams = httpParams.append('fileDesc', fileDesc);
		httpParams = httpParams.append('fileCategory', fileCategory);
		return this.httpClient.patch<SingleDocumentUploadModel>(Constants.ApiUrl + 'contacts/' + vehicleId + '/document/update', httpParams);
	}

	public deleteDocument(vehicleId: string, documentUri: string): Observable<Array<DocumentModel>>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.append('id', vehicleId);
		httpParams = httpParams.append('documentUri', documentUri);

		return this.httpClient.delete<Array<DocumentModel>>(Constants.ApiUrl + 'contacts/' + vehicleId + '/document/delete', { params: httpParams });
	}

    public async saveRecentContact(contact: ContactSummaryModel) {
        var val = await this.storage.get(Constants.IonicStorage_RecentContacts);

        var recentContacts = [];
        if (val) {
            recentContacts = JSON.parse(val);
            if (!Array.isArray(recentContacts)) {
                recentContacts = [];
            } else {
                recentContacts = recentContacts.filter(item => item.id !== contact.id);
            }
        }

        recentContacts.unshift(contact);

        if (recentContacts.length > 20) {
            recentContacts = recentContacts.slice(0, 20);
        }

        await this.storage.set(Constants.IonicStorage_RecentContacts, JSON.stringify(recentContacts));
    }

    public async removeRecentContact(contactId: string) {
        var val = await this.storage.get(Constants.IonicStorage_RecentContacts);

        var recentContacts = [];

        if (val) {
            recentContacts = JSON.parse(val);
            if (Array.isArray(recentContacts)) {
                recentContacts = recentContacts.filter(item => item.id !== contactId);
            }
        }

        await this.storage.set(Constants.IonicStorage_RecentContacts, JSON.stringify(recentContacts));
    }

    mergeContacts(contactFromId: string, contactToId: string, contactTo: ContactModel): Observable<ContactModel>
    {
        return this.httpClient.put<ContactModel>(Constants.ApiUrl + 'Contacts/Merge/' + contactFromId + '/' + contactToId, contactTo);
    }

    updateContactActive(contactId: string, active: boolean = null)
    {
        return this.httpClient.patch<boolean>(Constants.ApiUrl + 'Contacts/' + contactId + '/Active/' + active, '');
    }

    deleteContact(contactId: string)
    {
        return this.httpClient.delete<boolean>(Constants.ApiUrl + 'Contacts/' + contactId);
    }
}
